import { render, staticRenderFns } from "./AddRatingModal.vue?vue&type=template&id=838e0d1a&scoped=true"
import script from "./AddRatingModal.vue?vue&type=script&lang=js"
export * from "./AddRatingModal.vue?vue&type=script&lang=js"
import style0 from "./AddRatingModal.vue?vue&type=style&index=0&id=838e0d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e0d1a",
  null
  
)

export default component.exports